import { makeStyles } from '@material-ui/core';
import themes from 'styles/themes';

export const useStyles = makeStyles((theme) => ({
    fitContent: {
        width: '100%',
        height: '100%',
    },
    sizesWrapper: {
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'flex-start',
        alignItems: 'center',
    },
    boxSizes: {
        padding: '18px',
        width: '100%',
        height: '100%',
        maxHeight: '50vh',
        flexGrow: 1,
        overflowY: 'auto',
        position: 'relative',
        marginTop: 'auto',
        marginBottom: 'auto',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
    },
    boxItem: {
        borderRadius: 42,
        cursor: 'pointer',
        fontSize: 14,
        fontFamily: 'Poppins',
        zIndex: 5,
    },
    customeOption: {
        width: '100%',
        backgroundColor: themes.palette.common.white,
        minWidth: '100%',
        padding: '0px 30px',
        borderRadius: 42,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        fontFamily: 'Poppins',
        position: 'absolute',
        bottom: 12,
    },
    customeInput: {
        padding: '10px',
        border: '1px solid',
        borderRadius: 42,
        fontSize: 14,
        width: '100%',
        textAlign: 'center',
        position: 'relative',
    },
    unit: {
        position: 'absolute',
        right: 55,
        bottom: 0,
        zIndex: 2,
        height: '100%',
        display: 'flex',
        alignItems: 'center',
    },
    nextArrowBtn: {
        position: 'absolute',
        right: 18,
        top: 10,
    },
    container: {
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        padding: '16px',
    },
    styleContainer: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-evenly',
        width: '100%',
        height: '100%',
        flexDirection: 'column',
    },
    flexCenter: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
    },
    subtitle: {
        fontSize: '14px',
        fontFamily: 'PoppinsRegular',
        color: '#767676',
        textAlign: 'center',
    },
    title: {
        fontSize: 24,
        fontWeight: 600,
        marginBottom: 16,
        textAlign: 'center',
        fontFamily: 'Fraunces_120pt_SuperSoft_Wonky-Regular',
    },
    button: {
        width: '100%',
        height: 50,
        padding: 0,
        fontSize: 14,
        fontWeight: 600,
        fontFamily: 'PoppinsRegular',
        background: themes.palette.primary.main,
        borderRadius: '29px',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        textTransform: 'uppercase',
        border: 'none',
        marginBottom: 12,
        marginTop: 12,
    },
    skipBtn: {
        color: themes.palette.primary.main,
        textDecoration: 'none',
        textTransform: 'uppercase',
        fontFamily: 'PoppinsRegular',
        height: 44,
    },
    pickerContainer: {
        height: '315px',
        '@media (max-height: 695px)': {
            height: '200px',
        },
    },
    helpTitle: {
        alignSelf: 'center',
        textDecoration: 'underline',
        color: '#2188FF',
        marginTop: -4,
        fontFamily: 'PoppinsRegular',
        fontSize: 14,
    },
}));
